import React from 'react';
import { Switch, Route } from 'react-router-dom'
import Home from '../pages/Home'
import Siar from '../pages/Siar'
import ProcDig from '../pages/ProcDig'
import RecHum from '../pages/areas/RecHum'
import Conta from '../pages/areas/Conta'
import Vehic from '../pages/areas/Vehic'
import Mision from '../pages/Mision';
import Vision from '../pages/Vision';
import AvisoP from '../pages/AvisoP';
import Comunic from '../pages/Comunic';
import Construc from '../pages/Contruc';
import Qesq from '../pages/Qesq';
import ComBal from '../pages/ComBal';
import Reportes from '../pages/Reportes';
import Automatizacion from '../pages/automatizacion';

function Routes () {
    return (
        <Switch>
            <Route exact path= '/' component={Home} />
            <Route exact path= '/mision' component={Mision} />
            <Route exact path= '/vision' component={Vision} />
            <Route exact path= '/comunic' component={Comunic} />
            <Route exact path= '/combal' component={ComBal} />
            <Route exact path= '/aviso' component={AvisoP} />
            <Route exact path= '/siar' component={Siar} />
            <Route exact path= '/automatizacion' component={Automatizacion} />
            <Route exact path= '/qesq' component={Qesq} />
            <Route exact path= '/procdig' component={ProcDig} />
            <Route exact path= '/rechum' component={RecHum} />
            <Route exact path= '/conta' component={Conta} />
            <Route exact path= '/vehic' component={Vehic} />
            <Route exact path= '/construc' component={Construc} />
            <Route exact path= '/reportes' component={Reportes} />
        </Switch>
    )
}

export default Routes
